

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('ShippingDeliveryCtrl', function ($scope,$rootScope) {
$rootScope.title='Shipping and Delivery';


});

